import React from 'react';
import './UniversityPage.css';

const UniversityPage10 = () => {
    return (
        <>
            <div className="containerr">
                <header className="header">
                    <h1>University of Pavia</h1>
                    <h2>Medicine and Surgery Program</h2>
                </header>

                <section className="overview">
                    <h2>Overview</h2>
                    <p>The <strong>University of Pavia</strong> is one of Italy's most prestigious and historic universities, recognized for its excellence in medical education and research. The <strong>Medicine and Surgery</strong> program, taught entirely in English, attracts students from all over the world and offers an internationally recognized medical degree.</p>
                </section>

                <section className="ranking">
                    <h2>International Ranking of Pavia</h2>
                    <p>The <strong>University of Pavia</strong> consistently ranks among the top universities in Italy and holds a strong position in global rankings. According to the <strong>QS World University Rankings</strong>, it is one of the best medical schools in the country, offering high-quality education and outstanding research opportunities. It secures a rank of <strong>#410</strong> in the world and <strong>#12 in Italy</strong>.</p>
                </section>

                <section className="seats-available">
                    <h2>Seats Available</h2>
                    <p>The Medicine and Surgery program at Pavia has a limited number of seats available each year, divided between EU and non-EU students. The seat allocation typically follows this structure:</p>
                    <div className="table-container">
                        <table className="styled-table">
                            <thead>
                                <tr>
                                    <th>EU Students</th>
                                    <th>Non-EU Students</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>~103 seats</td>
                                    <td>~40 seats (39+1 Marco Polo in 2024)</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>

                <section className="imat-scores">
                    <h2>IMAT Scores in Past Years and Cut-Offs</h2>
                    <p>Admission to Pavia's medical program is based on the <strong>International Medical Admissions Test (IMAT)</strong>. The cut-off scores vary each year depending on the number of applicants and the exam difficulty. Below are the minimum IMAT scores from previous years:</p>
                    <div className="table-container">
                        <table className="styled-table">
                            <thead>
                                <tr>
                                    <th>Year</th>
                                    <th>Minimum Score (Non-EU)</th>
                                    <th>European Scores (First/Last Round)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>2020</td>
                                    <td>41.8</td>
                                    <td>First: 54.5 / Last: 45.3</td>
                                </tr>
                                <tr>
                                    <td>2021</td>
                                    <td>49.4</td>
                                    <td>First: 46.3 / Last: 35.5</td>
                                </tr>
                                <tr>
                                    <td>2022</td>
                                    <td>43.8</td>
                                    <td>First: 45.8 / Last: 36.7</td>
                                </tr>
                                <tr>
                                    <td>2023</td>
                                    <td>53.8</td>
                                    <td>First: 39.8 / Last: 38.4</td>
                                </tr>
                                <tr>
                                    <td>2024</td>
                                    <td>71.2</td>
                                    <td>First: 61.8 / Last: --</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>

                <section className="admission">
                    <h2>Admission Requirements</h2>
                    <p>To apply for the <strong>Medicine and Surgery</strong> program at Pavia, students must meet the following criteria:</p>
                    <ul>
                        <li>A valid <strong>high school diploma</strong> equivalent to the Italian system.</li>
                        <li>A competitive <strong>IMAT score</strong>.</li>
                        <li>Proficiency in <strong>English</strong> (minimum B2 level if required).</li>
                    </ul>
                </section>

                <section className="course-structure">
                    <h2>Course Structure and Subjects Taught</h2>
                    <p>The <strong>Medicine and Surgery</strong> program at Pavia is a <strong>6-year degree</strong> that follows a structured curriculum, divided into <strong>pre-clinical and clinical phases</strong>.</p>

                    <h3>First Year</h3>
                    <ul>
                        <li>Fundamentals of Medicine: Biochemistry, Biology, Physics, and Mathematics</li>
                        <li>Human Anatomy and Structure of the Body</li>
                        <li>Histology and Embryology</li>
                        <li>Ultrasound Laboratory Training</li>
                        <li>Social Aspects of Health and Disability</li>
                    </ul>

                    <h3>Second Year</h3>
                    <ul>
                        <li>Body Functions and Physiology</li>
                        <li>Medical Ethics and Society</li>
                        <li>Disease Biology and Mechanisms</li>
                        <li>Microbiology and Immunology</li>
                        <li>Laboratory Medicine</li>
                    </ul>

                    <h3>Third Year</h3>
                    <ul>
                        <li>Systemic Pathology and Disease Mechanisms</li>
                        <li>Clinical Foundations and Practical Training</li>
                        <li>Drug Discovery and Pharmacological Actions</li>
                        <li>Evolutionary Medicine</li>
                        <li>Haematological Disorders and Endocrine Diseases</li>
                        <li>Precision Medicine and Nanotechnology in Healthcare</li>
                    </ul>

                    <h3>Fourth Year</h3>
                    <ul>
                        <li>Neurological and Psychiatric Disorders</li>
                        <li>Cardiopulmonary and Sensory System Diseases</li>
                        <li>Soft Tissue, Gastrointestinal, and Urinary Tract Disorders</li>
                        <li>Complex Clinical Case Studies</li>
                    </ul>

                    <h3>Fifth Year</h3>
                    <ul>
                        <li>Paediatrics and Women's Health</li>
                        <li>General Surgery (Part I & II)</li>
                        <li>Clinical Pharmacology</li>
                        <li>Genetics and Advanced Pathology</li>
                        <li>Case-Based Learning and Practical Clinical Training</li>
                    </ul>

                    <h3>Sixth Year</h3>
                    <ul>
                        <li>Advanced Clinical Medicine and Patient Care</li>
                        <li>Thesis Research and Scientific Paper Presentation</li>
                        <li>Evaluative Traineeship in General Practice</li>
                    </ul>
                </section>

                <section className="tuition-fees">
                    <h2>Tuition Fees and Cost of Living</h2>
                    <p>The University of Pavia offers <strong>affordable tuition fees</strong>, ranging between <strong>€156 - €4,500 per year</strong>, depending on financial status and scholarships.</p>
                    <p>The University of Pavia's medical school offers affordable tuition, supported by <strong>ISEE</strong> and <strong>EDISU financial aid</strong>. With lower costs than many universities worldwide, students can focus on their education without heavy financial burdens. It provides high-quality medical training at a budget-friendly price.</p>
                    <p><strong>EDISU Scholarship:</strong> <a href="https://www.edisu.pv.it/uploads/Call%20for%20Scholarship%20applications%20for%20the%202024-2025%20per%20pubblicazione.pdf">EDISU Scholarship Link</a></p>

                    <h3>Estimated Monthly Living Costs in Pavia</h3>
                    <div className="table-container">
                        <table className="styled-table">
                            <thead>
                                <tr>
                                    <th>Expense</th>
                                    <th>Estimated Cost (€)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Accommodation</td>
                                    <td>300-600</td>
                                </tr>
                                <tr>
                                    <td>Food</td>
                                    <td>200-300</td>
                                </tr>
                                <tr>
                                    <td>Transport</td>
                                    <td>30-50</td>
                                </tr>
                                <tr>
                                    <td>Other Expenses</td>
                                    <td>100-200</td>
                                </tr>
                                <tr>
                                    <td><strong>Total</strong></td>
                                    <td><strong>700-1,200</strong></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p>Pavia is significantly <strong>more affordable</strong> than Milan, making it a great option for international students.</p>
                </section>

                <section className="city-info">
                    <h2>Life in Pavia</h2>
                    <p>Pavia is a small but vibrant university town, known for its welcoming atmosphere and historic beauty. Here is what makes Pavia an ideal place to study:</p>
                    <ul>
                        <li><strong>Historic Charm</strong> -- A city rich in culture, with medieval architecture and historic landmarks.</li>
                        <li><strong>Strong Student Community</strong> -- With thousands of students, the city is full of academic and social activities.</li>
                        <li><strong>Close to Milan</strong> -- Only 30 minutes from Milan, providing easy access to an international hub.</li>
                        <li><strong>Affordable Living</strong> -- Compared to Milan, Pavia offers a more budget-friendly lifestyle.</li>
                    </ul>
                </section>

                <footer className="footer">
                    <h2>Conclusion</h2>
                    <p>In conclusion, Pavia offers a dynamic and enriching experience for international students, blending quality education with a vibrant cultural life. With its historic charm, affordable living, and welcoming community, it provides the perfect environment for students to thrive academically and socially while enjoying the best of Italy.</p>
                </footer>
            </div>
        </>
    );
};

export default UniversityPage10;